import { render } from "./ResetPassword.vue?vue&type=template&id=231abe38&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=231abe38&lang=scss&scoped=true"
import "./ResetPassword.vue?vue&type=style&index=1&id=231abe38&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231abe38"]])

export default __exports__